import Network from '@/common/lib/Network';
import Store from '@/config/store';

export default {
  getOutStandingHeader() {
    return Network.execute('GET', 'CWEBS0054B', {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
    });
  },
  getOutStandingList() {
    return Network.execute('GET', 'CWEBS0055A', {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
    });
  }
}